import React from 'react';

import "./theme/_main.scss";

import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import {NarrowContainer} from '../../customizations/components/theme/Container/Container';

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;


    return (

        <div className="custom-block highlight-block">
            <NarrowContainer>
                {isEditMode ? (
                    <TextLineEdit
                        {...filteredToolbarProps}
                        renderTag="p"
                        fieldDataName="text"
                        properties={{ text: data.text }}
                    />
                ) : (
                    <p>
                        {data.text}
                    </p>
                )}
            </NarrowContainer>

        </div>


    );
};

export default View;
